import isMobile from 'is-mobile';

export function useIsMobile() {
  return isMobile();
}
